import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditClass from '../../components/classes/FormAddEditClass';

const CreateClass = () => (<WrapperSection><GlobalBreadcrumbs /><FormAddEditClass /></WrapperSection>);
export default CreateClass;
